<template>
    <vue-scroll class="login-page suspended-page align-vertical">
        <div class="form-wrapper align-vertical-middle">
            <div class="form-box card-base card-shadow--extraLarge">
                <div>
                    Please contact Becky at
                    <a href="mailto:becky@corwindesign.com"
                        >becky@corwindesign.com</a
                    >
                    to discuss your account.
                </div>
                <community-switcher />
                <el-button @click="logout()" class="mt-10" type="text">
                    <i class="mdi mdi-logout mr-10" /> Logout
                </el-button>
            </div>
        </div>
        <form
            action="/logout"
            method="post"
            ref="formLogout"
            style="display: none"
        >
            <input :value="csrf" name="_token" type="hidden" />
        </form>
    </vue-scroll>
</template>

<script>
import CommunitySwitcher from "@/components/CommunitySwitcher";

export default {
    components: {
        CommunitySwitcher,
    },
    computed: {
        csrf() {
            return this.$store.state.csrf;
        },
    },
    methods: {
        logout() {
            this.$refs.formLogout.submit();
        },
    },
};
</script>

<style scoped></style>
